<div *ngIf="loading" class="flex justify-center items-center h-full flex-1">
	<app-icon [icon]="ICON.LOADING" [spin]="true"></app-icon
	><span class="ml-2">{{ loadingStatus }}</span>
</div>

<div
	*ngIf="dataError"
	class="flex flex-col justify-center items-center h-full flex-1"
>
	<p class="mb-10">There was an error fetching the mortgage documents.</p>
	<div class="flex flex-1 justify-between w-full">
		<app-button size="small" (click)="close()">Close</app-button>
		<app-button size="small" (click)="GetDocuments()">Retry</app-button>
	</div>
</div>

<div *ngIf="!loading && !dataError" class="flex items-center flex-col">
	<p *ngIf="result > 0" class="mb-10">
		{{ result }} new documents available. Please review in the documents tab.
	</p>
	<p *ngIf="result === 0" class="mb-10">
		You are up to date. There are no new documents available.
	</p>
	<app-button (click)="close()" size="small"> Continue </app-button>
</div>
